import {
  hardCodeIsCaesarStone,
  hardCodeIsMcDermott,
  hardCodeIsModerno,
  hardCodeIsPorcelanosa,
  isProd
} from "../../misc/fabricatorHardcode";

export const isDevMode = () => {
  return window.location.href.includes("dev=1") || document.kvConfig.devMode
};

export const SQFT_POST_MESSAGE_ACTIONS = {
  initialLoad: "initialLoad",
  setQTData: "setQTData",
  closeSqFtCalc: "closeSqFtCalc",
  callResetDataPopup: "callResetDataPopup",
  callChangeLayoutDataPopup: "callChangeLayoutDataPopup",
  userIdleResetCounter: "userIdleResetCounter",
  resetHistory: "resetHistory",
  saveHistory: "saveHistory",
  setNewLayoutOnSqft: "setNewLayoutOnSqft",
  setCanvasCenter: "setCanvasCenter",
  stopRender: "stopRender",
  startRender: "startRender",
};

export const MEASURE_UNITS = {
  Metric: "Metric",
  Imperial: "Imperial",
};

/**
 *
 * This is used only to take shape part id
 * @type {{top_cabinet: string, bottom_cabinet: string, center_island_countertop: string, slabPlaceHolder: string, seamPiece: string, countertop: string, spacer: string, vanity_countertop: string, backsplashPiece: string}}
 */
export const SHAPE_PART_ID = {
  seamPiece: 'seamPiece',
  backsplashPiece: 'backsplashPiece',
  waterfallPiece: 'waterfallPiece',
  slabPlaceHolder: 'slabPlaceHolder',
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  countertop: 'countertop',
  spacer: 'spacer',
  vanity_countertop: 'vanity_countertop',
  center_island_countertop: 'center_island_countertop',
  dishwasher: "dishwasher",
  hood: "hood",
};

export const SHAPE_ROTATE_DIRECTION = {
  right: 0,
  left: 1,
};

export const ALIGN = {
  right: 'right',
  left: 'left',
  center: 'center',
};

export const SHAPE_TYPE = {
  polygon: "polygon",
  square: "square",
  wideangle: "wideangle",
  horseshoe: "horseshoe",
  appliances: "appliances",
};

export const RENDER_TEMPLATES = {
  default: "default",
  linesOnly: "linesOnly",
  filledPrimary: "filledPrimary",
  accordingToFeature: "accordingToFeature",
  filledActive: "filledActive",
};

/**
 * NAVIGATION
 */
export const SIDEBAR2_BUTTONS = [
  {
    menu: "summary",
    classNames: "button--parent button--summary",
    text: "mobile.summary",
    hasMenu: true
  },
  // {
  //   menu: "settings",
  //   classNames: "button--parent button--settings",
  //   text: "settings",
  //   hasMenu: true
  // }
];

export const SIDEBAR_BUTTONS_MENU = {
  move: "move",
  shapes: "shapes",
  layouts: "layouts",
  summary: "summary",
  delete: "delete",
  cabinetset: "cabinetset"
}

export const SIDEBAR_SLAB_BUTTONS = {
  move: "move",
  //moveSlab: "moveSlab",
  rotate: "rotate",
  loadSlab: "loadSlab",
  seam: "seam",
  duplicate: "duplicate",
  delete: "delete",
};

export const MOVABLE_IMAGE_TYPES = {
  slabImage: "slabImage",
};

export const SIDEBAR_SLAB_SEAM_BUTTONS = {
  addSeamHorizontal: "addSeamHorizontal",
  addSeamVertical: "addSeamVertical",
  undoSeam: "undoSeam",
  resetSeams: "resetSeams",
};

/**
 * remember to update SIDEBAR_HIDDEN_BUTTONS (names should be the same)
 */
export const SIDEBAR_NAVIGATION_BUTTONS = {
  move: "move",
  freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  radius: "radius",
  edge: "edge",
  backsplash: "backsplash",
  ...(!hardCodeIsCaesarStone() && {appliances: "appliances"}), // disable appliances for caes
  angle: "angle",
  bumpout: "bumpout",
  ...(!hardCodeIsCaesarStone() && {label: "label"}), // disable appliances for caes
  text: "text",
  mitered: "mitered",
  ...((!hardCodeIsMcDermott()) && {toolWaterfall: "toolWaterfall"}),
  ...((!isProd && (hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode())) && {toolUnderlayment: "toolUnderlayment"}),
  duplicate: "duplicate",
};

export const SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS = {
  move: "move",
  freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  edge: "edge",
  bumpout: "bumpout",
  mitered: "mitered",
  ...((hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode()) && {toolWaterfall: "toolWaterfall"}),
  ...(!hardCodeIsCaesarStone() && {label: "label"}), // disable appliances for caes
  text: "text",
  duplicate: "duplicate",
};

export const SIDEBAR_NAVIGATION_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  lower: "lower",
  upper: "upper",
  centerIsland: "centerIsland",
  spacer: "spacer",
  //style: "style",
  wall: "wall",
  crown: "crown",
  handles: "handles",
  ...(!hardCodeIsCaesarStone() && {appliances: "appliances"}), // disable appliances for caes
  text: "text",
};

export const SIDEBAR_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true
  }, {
    menu: "layouts",
    message: "sqft.navigation.menu.layouts",
    hasMenu: true
  }, ...(!hardCodeIsCaesarStone() && [{  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }]), {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_TYPE_AREA_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true
  }, ...(!hardCodeIsCaesarStone() && [{  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }]), {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
];

export const SIDEBAR_CABINET_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, ...(!hardCodeIsCaesarStone() ? [{  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }] : []), {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_HIDDEN_BUTTONS = {
  toolWaterfall: "toolWaterfall",
  toolUnderlayment: "toolUnderlayment",
  edgePeninsulaUnderwrap: "edgePeninsulaUnderwrap",
};

export const SIDEBAR_SHAPE_BUTTONS = {
  square: "square",
  lshape: "lshape",
  wideangle: "wideangle",
  rectangle: "rectangle",
  dot: "dot",
  freeDraw: "freeDraw",
};

/*
* Hide shapes after removing them in popup window
*/
export const isDisabledInPopupShouldBeHidden = () => {
  return hardCodeIsCaesarStone() //enabled only for caesarstone
}

export const SIDEBAR_LAYOUTS_BUTTONS = [
  "S", "SP", "SI", "SPI", "SN", "SPN", "SNI", "SPNI", "L", "LI", "LN", "LNI"
];

export const SQFT_APPLIANCES = {
  hood: "hood",
  refrigerator: "refrigerator",
  range: "range",
  sink: "sink",
  doubleSink: "doubleSink",
  dishwasher: "dishwasher",
  iceMachine: "ice machine",
  oven: "oven",
  stovetop: "stovetop",
  trashCompactor: "trash compactor",
  wineFridge: "wine fridge"
};

export const SQFT_CABINET_APPLIANCES = {
  //hood: "hood",
  //microwave: "microwave",
};

export const SQFT_APPLIANCES_WITH_SUBMENU = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  SQFT_CABINET_APPLIANCES.microwave,
  //partIds which names are mismatched
  'stove',
  'fridge',
]

export const SQFT_MODE = {
  regular: "regular",
  slab: "slab",
};

export const MANUAL_CALCULATION_ROW_TYPES = {
  countertopRows: "countertopRows",
  backsplashRows: "backsplashRows",
  edgeRows: "edgeRows",
};

export const DIRECTION = {
  north: "north",
  east: "east",
  south: "south",
  west: "west",
};

export const MANUAL_CALCULATION_MEASURE = {
  length: "length",
  height: "height",
  width: "width",
  selectedFeature: "selectedFeature",
};

export const SQFT_BACKSPLASH_TYPES = ["4", "6", "18"];
export const SQFT_WALL_TYPES = ["wall"];
export const SQFT_MEASURE_UNIT = {
  imperial: "Imperial",
  metric: "Metric",
};
export const FREE_DRAW_TYPE = {
  shape: "shape",
  wall: "wall",
};

export const CONTEXT_MENU_TYPE = {
  list: "list",
  buttons: "buttons",
};

export const SQFT_FEATURES = {
  countertop: 'countertop',
  center_island_countertop: 'center_island_countertop',
  slabs: 'slabs',
  backsplashes: 'backsplashes',
  edges: 'edges',
  radius: 'radius',
  corners: 'corners',
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  vanity_accent: 'vanity_accent',
  vanity_countertop: 'vanity_countertop',
  vanity_backsplash: 'vanity_backsplash',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  crown_molding: 'crown_molding',
  handle: 'handle',
  underlayment: 'underlayment',
};

export const SQFT_AREA_TYPE_PART_IDS = {
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
};

export const COUNTERTOP_LABELS = {
  center_island_countertop: 'center_island_countertop',
  countertop: 'countertop',
  vanity_countertop: 'vanity_countertop',
  vanity_accent: 'vanity_accent',
  shower_wall: 'shower_wall',
  shower_wall_accent: 'shower_wall_accent',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  accent_wall: 'accent_wall',
  shower_floor: 'shower_floor',
  bathroom_floor: 'bathroom_floor',
  kitchen_floor: 'kitchen_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
};

export const CABINET_LABELS = {
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  crown_molding: 'crown_molding',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  handle: 'handle',
};

export const CABINET_HANDLE_ALLOWED = {
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
};

export const CABINET_COMMON_COLOR_PART_IDS = {
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
};

export const FEATURE_QUANTITY_UNITS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet
];

export const BACKSPLASH_LABELS = {
  backsplash: 'backsplash',
  backsplashes: 'backsplashes',
  vanity_backsplash: 'vanity_backsplash',
};

export const EDGE_LABELS = {
  edge: 'edge',
  edge_profile: 'edge_profile',
  center_island_edge: 'center_island_edge',
};

export const CORNER_LABELS = {
  radius: 'radius',
  corner: 'corner',
};

// export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = [
//   SQFT_FEATURES.backsplashes,
//   SQFT_FEATURES.countertop,
//   SQFT_FEATURES.center_island_countertop,
//   SQFT_FEATURES.shower_wall,
//   SQFT_FEATURES.shower_floor,
//   SQFT_FEATURES.kitchen_floor,
//   SQFT_FEATURES.vanity_countertop,
//   SQFT_FEATURES.vanity_backsplash,
//   SQFT_FEATURES.shower_interior_wall,
//   SQFT_FEATURES.shower_interior_wall_accent,
//   SQFT_FEATURES.bathroom_floor,
//   SQFT_FEATURES.wall_a,
//   SQFT_FEATURES.wall_b,
//   SQFT_FEATURES.wall_c
// ];

export const SHAPE_PART_IDS_USING_SAME_COLOR = {
  ...COUNTERTOP_LABELS,
  waterfallPiece: SHAPE_PART_ID.waterfallPiece,
  backsplashPiece: SHAPE_PART_ID.backsplashPiece,
  seamPiece: SHAPE_PART_ID.seamPiece,
}

export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
}

export const ALLOWED_LABEL_NAV_ITEMS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  ...CABINET_LABELS,
  ...SQFT_AREA_TYPE_PART_IDS,
}

export const POINT_PROPERTY = {
  angle: 'angle',         // 45 degCorner
  arcLength: 'arcLength', // Radius
}

export const RESOURCE_TYPE = {
  attachedToLine: 'attachedToLine',
  waterfallSectionsData: 'waterfallSectionsData',
  underlaymentSections: 'underlaymentSections',
  selectedFeature: null
}

export const RESOURCE_ATTACHED_TO_TYPE = {
  edge: 'edge',
  backsplash: 'backsplash',
  wall: 'wall',
  mitered: 'mitered',
  underlayment: 'underlayment',
  bumpout: 'bumpout',
  waterfall: 'waterfall',
  crown_molding: 'crown_molding',
}

export const RESOURCE_ATTACHED_TO_NAME = {
  waterfall: 'Waterfall',
}

export const WORKSPACE_RESOURCES = {
  spacers: 'spacers',
  handles: 'handles',
  walls: 'walls',
  shapeColors: 'shapeColors',
  waterfall: 'waterfall',
  removedFeatures: 'removedFeatures',
  snappedShapeGroups: 'snappedShapeGroups',
}

/**
 * Should be unique
 * @type {{peninsulaUnderwrap: string, underlayment: string, waterfall: string, cabinetReturn: string, overhangReturn: string}}
 */
export const WATERFALL_SHAPES_KEY = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Ppeninsula Underwrap',
}

export const WATERFALL_SHAPES_NAME = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Underlayment',
}

export const SQFT_GROUP = {
  area: 'area',
  cabinets: 'cabinets',
}

export const SQFT_AR3D_POPUP_CONTENT_TYPE = {
  ar: 'ar',
  threeD: 'threeD',
}

export const WATERFALL_OVERLAY_TYPE = {
  waterfall: 'waterfall',
  peninsulaUnderwrap: 'peninsulaUnderwrap',
}

export const MITERED_OVERLAY_TYPE = {
  mitered: "mitered",
  underlayment: "underlayment",
}

export const APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE = [
  SQFT_APPLIANCES.sink,
  SQFT_APPLIANCES.doubleSink,
  SQFT_APPLIANCES.stovetop
]

export const CABINET_SET2 = {
  "positions": [
    {
      "partId": "top_cabinet",
      "x": 49.481212121212124,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-9-30-W.glb",
      "target_width": 9,
      "width": 9,
      "height": 30,
      "depth": 12,
      "featureId": 195671168,
      "parentFeatureId": 195796963
    },
    {
      "partId": "top_cabinet",
      "x": 40.48121212121211,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-9-36-SMW.glb",
      "target_width": 9,
      "width": 9,
      "height": 36,
      "depth": 12,
      "featureId": 195671213,
      "parentFeatureId": 195796963
    },
    {
      "partId": "top_cabinet",
      "x": 28.481212121212113,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-12-36-SMW.glb",
      "target_width": 12,
      "width": 12,
      "height": 36,
      "depth": 12,
      "featureId": 195671242,
      "parentFeatureId": 195796963
    },
    {
      "partId": "top_cabinet",
      "x": 10.48121212121211,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-18-30-W.glb",
      "target_width": 18,
      "width": 18,
      "height": 30,
      "depth": 12,
      "featureId": 195671272,
      "parentFeatureId": 195796963
    },
    {
      "partId": "top_cabinet",
      "x": -1.51878787878789,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-12-42-SMW.glb",
      "target_width": 12,
      "width": 12,
      "height": 42,
      "depth": 12,
      "featureId": 195671286,
      "parentFeatureId": 195796963
    },
    {
      "partId": "top_cabinet",
      "x": -16.518787878787904,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-15-36-SMW.glb",
      "target_width": 15,
      "width": 15,
      "height": 36,
      "depth": 12,
      "featureId": 195671397,
      "parentFeatureId": 195796963
    },
    {
      "partId": "top_cabinet",
      "x": -37.518787878787904,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-21-30-W.glb",
      "target_width": 21,
      "width": 21,
      "height": 30,
      "depth": 12,
      "featureId": 195671428,
      "parentFeatureId": 195796963
    },
    {
      "partId": "top_cabinet",
      "x": -61.51878787878788,
      "y": 52,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Top Cabinet-Light Italian Walnut-Bryant-24-36-SMDCW.glb",
      "target_width": 24,
      "width": 24,
      "height": 36,
      "depth": 12,
      "featureId": 195671547,
      "parentFeatureId": 195796963
    },
    {
      "partId": "bottom_cabinet",
      "x": -25.51878787878789,
      "y": 0,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-9-34.5-BT.glb",
      "target_width": 9,
      "width": 9,
      "height": 34,
      "depth": 24,
      "featureId": 195671300,
      "parentFeatureId": 195833433
    },
    {
      "partId": "bottom_cabinet",
      "x": 4.481212121212106,
      "y": 0,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-30-34.5-SB.glb",
      "target_width": 30,
      "width": 30,
      "height": 34,
      "depth": 24,
      "featureId": 195671316,
      "parentFeatureId": 195833433
    },
    {
      "partId": "bottom_cabinet",
      "x": 61.4812121212121,
      "y": 0,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-12-34.5-B.glb",
      "target_width": 12,
      "width": 12,
      "height": 34,
      "depth": 24,
      "featureId": 195671365,
      "parentFeatureId": 195833433
    },
    {
      "partId": "bottom_cabinet",
      "x": -16.518787878787887,
      "y": 0,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-21-34.5-B.glb",
      "target_width": 21,
      "width": 21,
      "height": 34,
      "depth": 24,
      "featureId": 195671759,
      "parentFeatureId": 195833433
    },
    {
      "partId": "bottom_cabinet",
      "x": 34.48121212121211,
      "y": 0,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-36-34.5-BBC.glb",
      "target_width": 27,
      "width": 27,
      "height": 34,
      "depth": 24,
      "featureId": 195671838,
      "parentFeatureId": 195833433
    },
    {
      "partId": "bottom_cabinet",
      "x": -61.518787878787904,
      "y": 0,
      "z": -132.04727272727277,
      "rotation": 0,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-36-34.5-SM-ERB-BER.glb",
      "target_width": 36,
      "width": 36,
      "height": 34,
      "depth": 24,
      "featureId": 195671868,
      "parentFeatureId": 195833433
    },
    {
      "partId": "bottom_cabinet",
      "x": -61.51878787878789,
      "y": 0,
      "z": -66.04727272727278,
      "rotation": 90,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-30-34.5-SB.glb",
      "target_width": 30,
      "width": 30,
      "height": 34,
      "depth": 24,
      "featureId": 195671316,
      "parentFeatureId": 195833433
    },
    {
      "partId": "bottom_cabinet",
      "x": -61.51878787878789,
      "y": 0,
      "z": -36.04727272727281,
      "rotation": 90,
      "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Bottom Cabinet-Light Italian Walnut-Bryant-30-34.5-SB.glb",
      "target_width": 30,
      "width": 30,
      "height": 34,
      "depth": 24,
      "featureId": 195671325,
      "parentFeatureId": 195833433
    }
  ],
  "countertop": {
    "main": "https://quotecountertops.com/video/sqft/cabinets/Quarter Round_Main Body.glb",
    "edge": "https://quotecountertops.com/video/sqft/cabinets/Quarter Round_Edge.glb",
    "corner": "https://quotecountertops.com/video/sqft/cabinets/Quarter Round_Corner.glb",
    "texture": "https://static6.depositphotos.com/1031174/647/i/450/depositphotos_6477080-stock-photo-grungy-background.jpg"
  }
}
